<template>
    <div>
        <v-card elevation="0">
            <v-card-subtitle style="text-align:right;">
                <v-dialog v-model="dialogAddUser" width="700" persistent>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn dark color="#81B622" v-bind="attrs" v-on="on">Add User</v-btn>
                    </template>
                    <v-card>
                        <v-toolbar color="#81B622" dark>
                            <v-toolbar-title>Add User</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="dialogAddUser = false">
                                <v-icon>mdi-close-thick</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card elevation="0">
                            <v-card-text>
                                <v-text-field v-model="searchTerm" label="Search Term" required hint="Please enter more than 2 characters" persistent-hint
                                    @keydown.enter="search()" @keydown="validate()">
                                </v-text-field>
                                <v-select v-model="type" :items="typeItems" label="Type" placeholder="Type" required @change="validate()"></v-select>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn class="white--text" color="#21B6A8" @click="search()" :disabled="!validated" :loading="searchloading">
                                    Search
                                </v-btn>
                            </v-card-actions>
                            <v-divider></v-divider>
                            <v-card-text>
                                <v-data-table :headers="searchHeaders" :items="searchItems" sort-by="cn" :loading="searchloading" items-per-page="5">
                                    <template v-slot:item.actions="{ item }">
                                        <v-btn icon color="#05445E" @click="addUser(item)" :disabled="item.inList">
                                            <v-icon>mdi-account-plus</v-icon>
                                        </v-btn>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </v-card><br />
                    </v-card>
                </v-dialog>
            </v-card-subtitle>
            <v-card-text v-if="!callloading">
                <v-row justify="center">
                    <v-col cols="7">
                        <v-text-field v-model="searchInner" outlined label="Name to be searched" type="text" prepend-inner-icon="mdi-magnify" hide-details dense @keydown.enter="searchName"></v-text-field>
                    </v-col>
                    <v-col cols="5">
                        <v-btn color="#4297A0" class="white--text" @click="searchName" :disabled="searchInner == ''" :loading="searchtermloading">Search</v-btn>&nbsp;
                        <v-btn color="#E57F84" class="white--text" @click="clearSearch" :disabled="searchInner == ''">Clear</v-btn>
                    </v-col>
                </v-row><br />
                <v-divider></v-divider><br />
                <v-expansion-panels v-model="panel" multiple v-if="!searchtermloading">
                    <v-expansion-panel v-for="user in userList" :key="user.username" @change="loadPermissions()">
                        <v-expansion-panel-header color="#D2E5D0" disable-icon-rotate>
                            {{ user.cn }}
                            <template v-slot:actions>
                                <v-icon @click="deleteUser(user)" color="#FC2E20">mdi-trash-can-outline</v-icon>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <EditPermissions :user="user" :departmentlist="departmentlist" v-if="panelvalue"/>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card-text>
            <v-card-text v-else>
                <v-row 
                    class="fill-height"
                    align-content="center"
                    justify="center"
                >
                    <v-container style="height: 400px;">
                        <v-row
                            class="fill-height"
                            align-content="center"
                            justify="center"
                        >
                            <v-col
                                class="text-subtitle-1 text-center"
                                cols="12"
                            >
                                Calling Permissions/Users...
                            </v-col>
                            <v-col cols="6">
                                <v-progress-linear
                                    color="#98B38F"
                                    indeterminate
                                    rounded
                                    height="6"
                                ></v-progress-linear>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-row>
            </v-card-text>
        </v-card>
        <v-dialog v-model="dialogDelete" width="500" persistent>
            <v-card>
                <v-toolbar color="#E56997" dark>Remove User</v-toolbar>
                <br />
                <v-card-text>
                    Deleting this user &#40;<b> {{ selectedDeleteUser.cn }} </b>&#41; will remove <b>ALL</b> permissions granted for this portal, including access.
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#3CACAE" text @click="dialogDelete = false" >
                        Cancel
                    </v-btn>
                    <v-btn color="#E56997" text @click="removeUserConfirm()" :loading="deleteloading">
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogAddPermission" persistent width="850">
            <v-card elevation="0">
                <v-toolbar dark color="#21B6A8">
                    <v-toolbar-title>Setting permissions for {{ selectedUser.cn+" ("+selectedUser.username+")" }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="closeAddPermissionDialog">
                        <v-icon>mdi-close-thick</v-icon>
                    </v-btn>
                </v-toolbar><br />
                <v-card-text>
                    <div style="border-style: solid; border-width: 1px; border-color: #05445E; padding: 5px;">
                        <v-row dense>
                            <v-col cols="12" class="font-weight-bold" style="color: #05445E"><v-icon color="#05445E">mdi-shield-lock-outline</v-icon>&nbsp;Admin</v-col>
                            <v-col cols="6">
                                <v-checkbox v-model="adminpermissionsmanage" label="Permissions Setting" dense hide-details :true-value="1" :false-value="0"></v-checkbox>
                            </v-col>
                            <v-col cols="6">
                                <v-checkbox v-model="setannouncement" label="Setting Announcement" dense hide-details :true-value="1" :false-value="0"></v-checkbox>
                            </v-col>
                        </v-row>
                    </div><br />
                    <div style="border-style: solid; border-width: 1px; border-color: #05445E; padding: 5px;">
                        <v-row dense>
                            <v-col cols="12" class="font-weight-bold" style="color: #05445E"><v-icon color="#05445E">mdi-office-building-cog</v-icon>&nbsp;Academic Department Configuration</v-col>
                            <v-col cols="4">
                                <v-checkbox v-model="getacademicdepartments" label="View Departments and disciplines settings" dense hide-details :true-value="1" :false-value="0" @change="checkDepartmentConfiguration"></v-checkbox>
                            </v-col>
                            <v-col cols="4">
                                <v-checkbox v-model="setacademicdepartment" label="Create/Edit Department settings" dense hide-details :true-value="1" :false-value="0" @change="checkDepartmentConfiguration"></v-checkbox>
                            </v-col>
                            <v-col cols="4">
                                <v-checkbox v-model="deleteacademicdepartment" label="Delete Department settings" dense hide-details :true-value="1" :false-value="0" @change="checkDepartmentConfiguration"></v-checkbox>
                            </v-col>
                        </v-row>
                    </div><br />
                    <div style="border-style: solid; border-width: 1px; border-color: #05445E; padding: 5px;">
                        <v-row dense>
                            <v-col cols="12" class="font-weight-bold" style="color: #05445E">
                                <v-icon color="#05445E">mdi-bank-outline</v-icon>&nbsp;Academic Department Access 
                                <v-progress-circular indeterminate color="#868B8E" v-if="departmentloading"></v-progress-circular>
                            </v-col>
                            <v-col cols="12">
                                <v-row>
                                    <v-col cols="4" v-for="group in departmentlist" :key="group">
                                        <v-row>
                                            <v-col cols="12" v-for="discipline in group" :key="discipline">
                                                <v-checkbox v-model="allowedDepartments" :label="discipline" :value="discipline" hide-details dense></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </div><br />
                    <div style="border-style: solid; border-width: 1px; border-color: #05445E; padding: 5px;">
                        <v-row dense>
                            <v-col cols="12" class="font-weight-bold" style="color: #05445E"><v-icon color="#05445E">mdi-newspaper-variant-outline</v-icon>&nbsp;Posting</v-col>
                            <v-col cols="6">
                                <v-checkbox v-model="postingwrite" label="Create/Edit Job Postings" dense hide-details :true-value="1" :false-value="0"></v-checkbox>
                            </v-col>
                            <v-col cols="6">
                                <v-checkbox v-model="postingapprove" label="Approve Job Postings" dense hide-details :true-value="1" :false-value="0"></v-checkbox>
                            </v-col>
                            <v-col cols="6">
                                <v-checkbox v-model="postingstop" label="Stop Job Postings" dense hide-details :true-value="1" :false-value="0"></v-checkbox>
                            </v-col>
                            <v-col cols="6">
                                <v-checkbox v-model="postingdelete" label="Delete Job Postings" dense hide-details :true-value="1" :false-value="0"></v-checkbox>
                            </v-col>
                            <v-col cols="6">
                                <v-checkbox v-model="timetableinterface" label="Upload Timetable/Manage Custom Timetable" dense hide-details :true-value="1" :false-value="0"></v-checkbox>
                            </v-col>
                            <v-col cols="6">
                                <v-checkbox v-model="postingliveedit" label="Edit Active Postings" dense hide-details :true-value="1" :false-value="0"></v-checkbox>
                            </v-col>
                            <v-col cols="6">
                                <v-checkbox v-model="offerlettergenerate" label="Generate Offer Letter" dense hide-details :true-value="1" :false-value="0"></v-checkbox>
                            </v-col>
                            <v-col cols="6">
                                <v-checkbox v-model="postingfill" label="Mark Posting Filled" dense hide-details :true-value="1" :false-value="0"></v-checkbox>
                            </v-col>
                        </v-row>
                    </div><br />
                    <div style="border-style: solid; border-width: 1px; border-color: #05445E; padding: 5px;">
                        <v-row dense>
                            <v-col cols="12" class="font-weight-bold" style="color: #05445E"><v-icon color="#05445E">mdi-account-eye-outline</v-icon>&nbsp;Accounts/Applicants</v-col>
                            <v-col cols="6">
                                <v-checkbox v-model="getaccountslist" label="View Account Manager" dense hide-details :true-value="1" :false-value="0"></v-checkbox>
                            </v-col>
                            <v-col cols="6">
                                <v-checkbox v-model="setADOflag" label="ADO Contact Flagging" dense hide-details :true-value="1" :false-value="0"></v-checkbox>
                            </v-col>
                            <v-col cols="6">
                                <v-checkbox v-model="setHRflag" label="View/Set HR Flag" dense hide-details :true-value="1" :false-value="0"></v-checkbox>
                            </v-col>
                        </v-row>
                    </div><br />
                    <div style="border-style: solid; border-width: 1px; border-color: #05445E; padding: 5px;">
                        <v-row dense>
                            <v-col cols="12" class="font-weight-bold" style="color: #05445E"><v-icon color="#05445E">mdi-format-list-checks</v-icon>&nbsp;Application</v-col>
                            <v-col cols="6"><v-select v-model="searchrange" :items="searchrangeitems" label="Search Range" outlined dense hide-details></v-select></v-col>
                            <v-col cols="6"></v-col>
                            <v-col cols="4">
                                <v-checkbox v-model="adminformcontrol" label="Modify Form Configuration" dense hide-details :true-value="1" :false-value="0"></v-checkbox>
                            </v-col>
                            <v-col cols="4">
                                <v-checkbox v-model="justifications" label="Justification Comments" dense hide-details :true-value="1" :false-value="0"></v-checkbox>
                            </v-col>
                            <v-col cols="4">
                                <v-checkbox v-model="managercomments" label="Manager Comments" dense hide-details :true-value="1" :false-value="0"></v-checkbox>
                            </v-col>
                            <v-col cols="4">
                                <v-checkbox v-model="seniorityPoints" label="Modify Seniority Points" dense hide-details :true-value="1" :false-value="0"></v-checkbox>
                            </v-col>
                            <v-col cols="4">
                                <v-checkbox v-model="replaceCV" label="Replace Applicant Resume/CV" dense hide-details :true-value="1" :false-value="0"></v-checkbox>
                            </v-col>
                            <v-col cols="4">
                                <v-checkbox v-model="setemail" label="Edit Email Receipt" dense hide-details :true-value="1" :false-value="0"></v-checkbox>
                            </v-col>
                        </v-row>
                    </div><br />
                    <div style="border-style: solid; border-width: 1px; border-color: #05445E; padding: 5px;">
                        <v-row dense>
                            <v-col cols="12" class="font-weight-bold" style="color: #05445E"><v-icon color="#05445E">mdi-file-export-outline</v-icon>&nbsp;Export</v-col>
                            <v-col cols="4">
                                <v-checkbox v-model="exportdata" label="Export Applicant Data" dense hide-details :true-value="1" :false-value="0"></v-checkbox>
                            </v-col>
                            <v-col cols="4">
                                <v-checkbox v-model="exposeAll" label="Expose 'All' option for Disciplines" dense hide-details :true-value="1" :false-value="0"></v-checkbox>
                            </v-col>
                            <v-col cols="4">
                                <v-checkbox v-model="exportAllowAnyCourse" label="Use 'Any' for Course" dense hide-details :true-value="1" :false-value="0"></v-checkbox>
                            </v-col>
                        </v-row>
                    </div><br />
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="#21B6A8" @click="setPermissions" :loading="addloading">Set Permissions</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import EditPermissions from './EditPermissions.vue';
export default {
    components: {
        EditPermissions
    },
    data(){
        return {
            host: location.hostname.toString(),
            callloading: true,
            panel: [],
            dialogAddUser: false,
            searchTerm: '',
            type: 'people',
            typeItems: [{
                text: 'Department',
                value: 'department'
            }, {
                text: 'People',
                value: 'people'
            }],
            validated: false,
            searchloading: false,
            searchHeaders: [
                {text: 'Name', align: 'start', value: 'cn'},
                {text: 'Department', value: 'department'},
                {text: 'Email', value: 'mail'},
                {sortable: false, text: '', value: 'actions'}
            ],
            searchItems: [],
            userList: [],
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            panelvalue: false,
            dialogDelete: false,
            dialogAddPermission: false,
            selectedUser: {},
            selectedDeleteUser: {},
            departmentloading: true,
            departmentlist: [],
            searchrangeitems: ['All','Current Calendar Year Only', 'Previous and Current Calendar Year'],
            adminpermissionsmanage: 0,
            setannouncement: 0,
            getacademicdepartments: 0,
            setacademicdepartment: 0,
            deleteacademicdepartment: 0,
            allowedDepartments: [],
            postingwrite: 0,
            postingapprove: 0,
            postingstop: 0,
            postingdelete: 0,
            timetableinterface: 0,
            postingliveedit: 0,
            offerlettergenerate: 0,
            postingfill: 0,
            getaccountslist: 0,
            searchrange: "",
            adminformcontrol: 0,
            justifications: 0,
            managercomments: 0,
            setADOflag: 0,
            seniorityPoints: 0,
            replaceCV: 0,
            setemail: 0,
            exportdata: 0,
            exposeAll: 0,
            exportAllowAnyCourse: 0,
            setHRflag: 0,
            addloading: false,
            deleteloading: false,
            searchInner: "",
            searchtermloading: false
        }
    },
    methods: {
        getPermissionUsers(){
            const that = this;
            that.callloading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getPermissions';
            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        if(json.data.length > 0){
                            that.userList = json.data;
                        }
                    }else {
                        that.setSnackbar("Warning: "+json.message, "#EF6C00"); //orange
                    }

                    that.callloading = false;
                    that.searchtermloading = false;
                    
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.callloading = false;
                })
        },
        getDepartment(){
            const that = this;
            that.departmentloading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getacademicdepartments';
            that.departmentlist = [];
            var deps = []
            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        if(json.data.length > 0){
                            json.data.forEach(element => {
                                deps.push(element["department"]);
                            });
                        }
                        
                        let mid = Math.ceil(deps.length / 3);

                        for(let col = 0; col < 3 ; col++){
                            that.departmentlist.push(deps.slice(col*mid, col*mid+mid));
                        }
                    }else {
                        that.setSnackbar("Warning: "+json.message, "#EF6C00"); //orange
                    }

                    that.departmentloading = false;
                    
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.departmentloading = false;
                })
        },
        validate(){
            const that = this;

            if(that.searchTerm.length > 2){
                that.validated = true;
            }else {
                that.validated = false;
            }
        },
        search() {
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/mkvn/controller.api.kdap.pl?search&type='+that.type+'&term='+that.searchTerm+'&bypassFilters=removetestaccounts'

            that.searchloading = true;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    if(json.hasOwnProperty("Warning")){
                        that.setSnackbar("Warning: "+json.Warning, "#FF8300");
                    }else {
                        json.forEach(result => {
                            that.userList.forEach(element => {
                                if(element["username"] == result["sAMAccountName"]){
                                    result["inList"] = true;
                                }else {
                                    result["inList"] = false;
                                }
                            });
                        });

                        that.searchItems = json;
                        that.setSnackbar("User search Successful!", "#18A558");

                        that.searchTerm = "";
                        that.type = "people";
                    }

                    that.searchloading = false;
                    that.validated = false;
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err, "#FF4500");
                    that.searchloading = false;
                    that.validated = false;
                });
        },
        addUser(item){
            const that = this;

            let selected = {
                cn : item.cn,
                department: item.department,
                username: item.sAMAccountName,
                email: item.mail
            }

            that.searchItems = [];

            that.selectedUser = selected;
            that.dialogAddPermission = true;
        },
        closeAddPermissionDialog(){
            const that = this;
            that.dialogAddPermission = false;
            that.selectedUser = {};
            that.resetFormData();
        },
        loadPermissions(){
            const that = this;
            that.panelvalue = false;
            that.panelvalue = true;
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        },
        deleteUser(user){
            const that= this;
            that.selectedDeleteUser = user;
            that.dialogDelete = true;
        },
        removeUserConfirm(){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?deletePermissions&data={"username": "'+that.selectedDeleteUser.username+'"}'

            that.deleteloading = true;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (data) {
                    if(data.result.match(/ok/i)){
                        that.setSnackbar("Successful: "+data.message.toString(), "green");
                        that.getPermissionUsers();
                        that.selectedDeleteUser = {};
                        that.dialogDelete = false;
                    }else {
                        that.setSnackbar("Warning: "+data.message.toString(), "orange");
                    }

                    that.deleteloading = false;
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err, "#FF4500");
                    that.deleteloading = false;
                });
        },
        checkDepartmentConfiguration(){
            const that = this;
            if(that.setacademicdepartment == 1 || that.deleteacademicdepartment == 1){
                that.getacademicdepartments = 1;
            }
        },
        setPermissions(){
            const that = this;
            that.addloading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';

            let userpermission = {
                username: that.selectedUser.username,
                cn : that.selectedUser.cn,
                department: that.selectedUser.department,
                email: that.selectedUser.email,
                adminpermissionsmanage: that.adminpermissionsmanage,
                setannouncement: that.setannouncement,
                getacademicdepartments: that.getacademicdepartments,
                setacademicdepartment: that.setacademicdepartment,
                deleteacademicdepartment: that.deleteacademicdepartment,
                allowedDepartments: that.allowedDepartments,
                postingwrite: that.postingwrite,
                postingapprove: that.postingapprove,
                postingstop: that.postingstop,
                postingdelete: that.postingdelete,
                timetableinterface: that.timetableinterface,
                postingliveedit: that.postingliveedit,
                offerlettergenerate: that.offerlettergenerate,
                postingfill: that.postingfill,
                getaccountslist: that.getaccountslist,
                searchrange: that.searchrange,
                adminformcontrol: that.adminformcontrol,
                justifications: that.justifications,
                managercomments: that.managercomments,
                setADOflag: that.setADOflag,
                seniorityPoints: that.seniorityPoints,
                replaceCV: that.replaceCV,
                setemail: that.setemail,
                exportdata: that.exportdata,
                exposeAll: that.exposeAll,
                exportAllowAnyCourse: that.exportAllowAnyCourse,
                setHRflag: that.setHRflag
            }

            const formData = new FormData();
            formData.append("mode", "setpermission");
            formData.append("data", JSON.stringify(userpermission));

            fetch(api, {
                method: 'POST',
                body: formData
            })
            .then(function(response){
                return response.json();
            })
            .then(function (data) {
                if(data.result.match(/ok/i)){
                    that.setSnackbar("Successful: "+data.message.toString(), "green");
                    that.dialogAddPermission = false;
                    that.getPermissionUsers();
                    that.selectedUser = {};
                    that.resetFormData();
                }else {
                    that.setSnackbar("Warning: "+data.message.toString(), "orange");
                }

                that.addloading = false;
            })
            .catch(function (err) {
                that.setSnackbar("Error occurred : "+err.toString(), "red");
                that.addloading = false;
            })
        },
        resetFormData(){
            const that = this;
            that.adminpermissionsmanage = 0;
            that.setannouncement = 0;
            that.getacademicdepartments = 0;
            that.setacademicdepartment = 0;
            that.deleteacademicdepartment = 0;
            that.allowedDepartments = [];
            that.postingwrite = 0;
            that.postingapprove = 0;
            that.postingstop = 0;
            that.postingdelete = 0;
            that.timetableinterface = 0;
            that.postingliveedit = 0;
            that.offerlettergenerate = 0;
            that.postingfill = 0;
            that.getaccountslist = 0;
            that.searchrange = "";
            that.adminformcontrol = 0;
            that.justifications = 0;
            that.managercomments = 0;
            that.setADOflag = 0;
            that.seniorityPoints = 0;
            that.replaceCV = 0;
            that.setemail = 0;
            that.exportdata = 0;
            that.exposeAll = 0;
            that.exportAllowAnyCourse = 0;
            that.setHRflag = 0;
        },
        searchName(){
            const that = this;
            let searchList = [];

            if(that.searchInner != ""){
                that.searchtermloading = true;
                var regex = new RegExp(that.searchInner, "i");
                that.userList.forEach(element => {
                    if(regex.test(element["cn"])){
                        searchList.push(element)
                    }
                });
                
                if(searchList.length == 0){
                    that.setSnackbar("No result found using the search term '"+that.searchInner+"'", "#E1C340");
                }else {
                    that.userList = searchList;
                }

                that.searchtermloading = false;
            }else {
                that.getPermissionUsers();
            }
        },
        clearSearch(){
            const that = this;
            that.searchInner = "";
            that.userList = [];
            that.getPermissionUsers();
        }
        /*
        reloadData(){
            const that = this;
            if(that.panel.length == 0){
                that.getPermissionUsers();
            }
        }
        */
    },
    created(){
        const that = this;
        that.getDepartment();
        that.getPermissionUsers();
    }
}
</script>
